// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineRight } from 'react-icons/ai';
import RainbowText from '../../../common/rainbowText';
import { useHistory } from 'react-router-dom';

import './index.scss';
import News from './News';
import { TOP_IMAGES } from '../../../../../assets/imgs';

export default function ListNews(props) {
  const { listNews } = props;
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className="list-news">
      <div className="list-news-header">
        <div className="list-news-icon">
          <img src={TOP_IMAGES.News} />
        </div>
        <div className="list-news-title AOTFShinMaruGoPro">お知らせ</div>
      </div>
      <div className="list-news-content">
        {!listNews.length ? (
          <div />
        ) : (
          listNews.map((item, index) => <News news={item} key={index} />)
        )}
      </div>
      <div className="list-news-see-all" onClick={() => history.push('/news')}>
        <span>お知らせ一覧へ</span> {'>'}
      </div>
    </div>
  );
}
